import { render, staticRenderFns } from "./CenterCreateUpdate.vue?vue&type=template&id=70b7c6f6&scoped=true&"
import script from "./CenterCreateUpdate.vue?vue&type=script&lang=js&"
export * from "./CenterCreateUpdate.vue?vue&type=script&lang=js&"
import style0 from "./CenterCreateUpdate.vue?vue&type=style&index=0&id=70b7c6f6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70b7c6f6",
  null
  
)

export default component.exports